/*
 DependencyInjection.tsx
 =========

------------------------------------------------------------------------
 Author:   Lucas Meier                                        2025-08-29
 Modifs:

 Goal:   Used for FUOTA status tracking & management for TRACE.

   (c) 2025 Lucas Meier
   --------------------------

   CSEM S.A.
   Jaquet-Droz 1
   CH-2000 Neuchâtel
   http://www.csem.ch


   THIS SOFTWARE IS CONFIDENTIAL AND CANNOT BE DISTRIBUTED
   WITHOUT THE CSEM PRIOR WRITTEN AGREEMENT.

   THIS  SOFTWARE CAN ONLY BE USED IN THE EUROPEAN PROJECT TRACE AND
   SHALL REMAIN PRIVATE AT ALL TIMES.

------------------------------------------------------------------------
*/

import * as React from 'react';
import { Container } from 'inversify';
import { Provider } from 'inversify-react';
import { UserService } from './UserService';
import { Credentials } from './Credentials';
import { createClient } from './MQTTClient';
import { mqtt5 } from 'aws-iot-device-sdk-v2';
import { API, createClient as createHttpClient } from './HTTP';

export type MQTTClientProvider = () => Promise<mqtt5.Mqtt5Client>;

// in functional component
export const DependencyInjection: React.FC<{children: any}> = (props) => {
    return (
        <Provider container={() => {
            const container = new Container();

            container.bind<UserService>(UserService).toSelf();
            container.bind<Credentials>(Credentials).toSelf();
            container.bind<API>("API").toDynamicValue(_ => createHttpClient());

            container.bind<MQTTClientProvider>("MQTTClientProvider").toProvider((context) => {
                console.log(context);
                return () => createClient(context);
            })
            return container;
        }}>
            {props.children}
        </Provider>
    );
};